import React from "react"

const NavSignOut = ({ children, href }) => {
  return (
    <li>
      <a
        href={href}
        data-method='delete'
        className='relative flex flex-row items-center h-11 text-gray-600 focus:outline-none hover:bg-red-200 border-l-4 border-opacity-0 hover:border-red-500 pr-6'
      >
        <span className='inline-flex justify-center items-center ml-4 text-red-400'/>
        <span className='ml-2 font-semibold text-sm tracking-wide truncate font-sans'>
          {children}
        </span>
      </a>
    </li>
  )
}

export default NavSignOut
